import React, { FC } from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { Button } from '@shared/components/Button';

export type DeleteConfirmPopoverProps = {
    anchorEl: HTMLElement | null;
    onConfirm: () => void;
    onCancel: () => void;
    message?: string;
    confirmText?: string;
};

export const DeleteConfirmPopover: FC<DeleteConfirmPopoverProps> = ({
    anchorEl,
    onConfirm,
    onCancel,
    message = 'This action cannot be undone.',
    confirmText = 'Delete',
}) => (
    <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onCancel}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{
            elevation: 8,
            sx: {
                borderRadius: '12px',
                minWidth: 240,
                maxWidth: 290,
            },
        }}
    >
        <Box sx={{ p: '16px 18px 14px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Box
                    sx={{
                        width: 32,
                        height: 32,
                        borderRadius: '8px',
                        background: 'rgba(211, 47, 47, 0.10)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    <DeleteOutlineIcon sx={{ color: '#d32f2f', fontSize: 18 }} />
                </Box>
                <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#1a1a2e', lineHeight: 1.3 }}>
                    Confirm deletion
                </Typography>
            </Box>

            <Typography sx={{ fontSize: 12.5, color: '#666', lineHeight: 1.55 }}>
                {message}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    gap: '8px',
                    justifyContent: 'flex-end',
                    borderTop: '1px solid #f0f0f5',
                    pt: '10px',
                }}
            >
                <Button
                    color="secondary"
                    onClick={onCancel}
                    sx={{ minWidth: 72, height: 32, fontSize: 12.5 }}
                >
                    Cancel
                </Button>
                <Button
                    color="error"
                    onClick={onConfirm}
                    sx={{ minWidth: 72, height: 32, fontSize: 12.5 }}
                >
                    {confirmText}
                </Button>
            </Box>
        </Box>
    </Popover>
);
